import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ConversionEngineSettings } from '../../../../../model/conversion-engine-settings.model';

@Component({
  selector: 'auto-vdp-offers',
  templateUrl: './vdp-offers.component.html',
  styleUrls: ['./vdp-offers.component.scss']
})
export class VdpOffersComponent implements OnInit, OnChanges {
  @Input() data: ConversionEngineSettings | null = null;
  @Output() formGroupInitialized = new EventEmitter<UntypedFormGroup>();

  form: UntypedFormGroup;

  constructor(private formBuilder: UntypedFormBuilder) {
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      vdpOfferWidgetEnabled: [false, Validators.required]
    });
    this.formGroupInitialized.emit(this.form);
  }

  ngOnChanges(changes: SimpleChanges): void {
    const hasIncoming = !!this.data && !!this.form;
    if (hasIncoming) {
      this.form.patchValue({
        vdpOfferWidgetEnabled: !!this.data.vdpOfferWidgetEnabled
      }, { emitEvent: false });
      this.form.markAsPristine();
    }
  }
}
